import { LabelItemProps } from '@/types/product';
import { FC, useMemo } from 'react';
import { twMerge } from 'tailwind-merge';
import LabelOffIcon from '../../sku-product/meta/label-off-icon';

type ProductBigOffLabelProps = {
  labelOffType?: string;
  discount_percentage?: number;
  labelItem?: LabelItemProps;
};

const ProductBigOffLabel: FC<ProductBigOffLabelProps> = ({ labelOffType, discount_percentage, labelItem }) => {
  const LabelOffStyle = useMemo(() => {
    if (labelOffType === 'large') {
      return {
        containerWrapperCls: '-left-2 -top-2',
        containerCls: 'w-[116px] h-[116px]',
        mainTextCls: 'text-[38px] leading-100 mr-0.5',
        subTextCls1: 'text-[20px] font-medium leading-100',
        subTextCls2: 'text-[12px] font-medium leading-100'
      };
    }
    return {
      containerWrapperCls: '-left-1 -top-1',
      containerCls: 'w-[76px] h-[76px]',
      mainTextCls: 'text-[24px] leading-100 mr-0.5',
      subTextCls1: 'text-[14px] font-medium leading-100',
      subTextCls2: 'text-[8px] font-medium leading-100'
    };
  }, [labelOffType]);

  const labelList = labelItem?.label_name.split(' ');
  if (labelList.length < 2) return null;

  return (
    <div
      className={twMerge('absolute left-0 top-0', LabelOffStyle.containerWrapperCls)}
      data-testid={'wid-product-card-big-off-label'}>
      <div className={twMerge('relative flex items-center justify-center', LabelOffStyle.containerCls)}>
        <LabelOffIcon className="absolute inset-0 w-full h-full" />
        <div className="relative flex items-center justify-center text-white">
          <span className={twMerge('font-semibold leading-110', LabelOffStyle.mainTextCls)}>{discount_percentage}</span>
          <div className="font-medium leading-110">
            <div className={LabelOffStyle.subTextCls1}>%</div>
            <div className={LabelOffStyle.subTextCls2}>{labelList[1]}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductBigOffLabel;
